import React, { useState } from 'react';
import { StethoscopeIcon, ClockIcon, CalendarIcon } from 'lucide-react';
interface DoctorScheduleProps {
  persona: 'patient' | 'receptionist';
}
const mockDoctors = [{
  id: 1,
  name: 'Dr. Sarah Johnson',
  specialty: 'Cardiologist',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop',
  schedule: {
    Monday: ['9:00 AM - 1:00 PM', '2:00 PM - 5:00 PM'],
    Tuesday: ['9:00 AM - 1:00 PM', '2:00 PM - 5:00 PM'],
    Wednesday: ['9:00 AM - 1:00 PM'],
    Thursday: ['9:00 AM - 1:00 PM', '2:00 PM - 5:00 PM'],
    Friday: ['9:00 AM - 1:00 PM', '2:00 PM - 5:00 PM'],
    Saturday: ['9:00 AM - 12:00 PM'],
    Sunday: ['Unavailable']
  },
  availability: 'Available'
}, {
  id: 2,
  name: 'Dr. Michael Chen',
  specialty: 'Neurologist',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop',
  schedule: {
    Monday: ['10:00 AM - 2:00 PM', '3:00 PM - 6:00 PM'],
    Tuesday: ['10:00 AM - 2:00 PM', '3:00 PM - 6:00 PM'],
    Wednesday: ['10:00 AM - 2:00 PM', '3:00 PM - 6:00 PM'],
    Thursday: ['10:00 AM - 2:00 PM'],
    Friday: ['10:00 AM - 2:00 PM', '3:00 PM - 6:00 PM'],
    Saturday: ['Unavailable'],
    Sunday: ['Unavailable']
  },
  availability: 'Busy'
}, {
  id: 3,
  name: 'Dr. Emily Davis',
  specialty: 'Pediatrician',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=150&h=150&fit=crop',
  schedule: {
    Monday: ['8:00 AM - 12:00 PM', '1:00 PM - 4:00 PM'],
    Tuesday: ['8:00 AM - 12:00 PM', '1:00 PM - 4:00 PM'],
    Wednesday: ['8:00 AM - 12:00 PM', '1:00 PM - 4:00 PM'],
    Thursday: ['8:00 AM - 12:00 PM', '1:00 PM - 4:00 PM'],
    Friday: ['8:00 AM - 12:00 PM'],
    Saturday: ['Unavailable'],
    Sunday: ['Unavailable']
  },
  availability: 'Available'
}];
export function DoctorSchedule({
  persona
}: DoctorScheduleProps) {
  const [selectedDoctor, setSelectedDoctor] = useState<number | null>(null);
  const selectedDoctorData = mockDoctors.find(d => d.id === selectedDoctor);
  return <div className="space-y-6" data-id="element-153">
      {/* Doctor Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-154">
        {mockDoctors.map(doctor => <button key={doctor.id} onClick={() => setSelectedDoctor(doctor.id)} className={`bg-white rounded-lg shadow-sm border-2 p-6 text-left transition-all hover:shadow-md ${selectedDoctor === doctor.id ? 'border-blue-600' : 'border-gray-200'}`} data-id="element-155">
            <div className="flex items-center space-x-4 mb-4" data-id="element-156">
              <img src={doctor.image} alt={doctor.name} className="w-16 h-16 rounded-full object-cover" data-id="element-157" />
              <div data-id="element-158">
                <h3 className="font-semibold text-gray-900" data-id="element-159">{doctor.name}</h3>
                <p className="text-sm text-gray-600" data-id="element-160">{doctor.specialty}</p>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-161">
              <span className={`px-3 py-1 text-xs font-medium rounded-full ${doctor.availability === 'Available' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-162">
                {doctor.availability}
              </span>
              <span className="text-sm text-blue-600" data-id="element-163">View Schedule →</span>
            </div>
          </button>)}
      </div>
      {/* Doctor Schedule Details */}
      {selectedDoctorData && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-164">
          <div className="flex items-center space-x-3 mb-6" data-id="element-165">
            <StethoscopeIcon className="w-6 h-6 text-blue-600" data-id="element-166" />
            <h2 className="text-2xl font-bold" data-id="element-167">
              {selectedDoctorData.name} - Weekly Schedule
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-168">
            {Object.entries(selectedDoctorData.schedule).map(([day, times]) => <div key={day} className="p-4 border border-gray-200 rounded-lg" data-id="element-169">
                <div className="flex items-center space-x-2 mb-3" data-id="element-170">
                  <CalendarIcon className="w-4 h-4 text-blue-600" data-id="element-171" />
                  <h3 className="font-semibold text-gray-900" data-id="element-172">{day}</h3>
                </div>
                <div className="space-y-2" data-id="element-173">
                  {times.map((time, idx) => <div key={idx} className={`flex items-center space-x-2 text-sm ${time === 'Unavailable' ? 'text-red-600' : 'text-gray-700'}`} data-id="element-174">
                      <ClockIcon className="w-3 h-3" data-id="element-175" />
                      <span data-id="element-176">{time}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
          <div className="mt-6 flex justify-end" data-id="element-177">
            <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-178">
              Book Appointment with {selectedDoctorData.name}
            </button>
          </div>
        </div>}
    </div>;
}